import { useEffect, useMemo, useState } from 'react';

export default function useCountdown(targetDate) {
    const [secondsLeft, setSecondsLeft] = useState(0);

    useEffect(() => {
        if (!targetDate) return;
        const target = new Date(targetDate).getTime();
        const tick = () => {
            const diff = Math.max(0, Math.floor((target - Date.now()) / 1000));
            setSecondsLeft(diff);
        };
        tick();
        const id = setInterval(tick, 1000);
        return () => clearInterval(id);
    }, [targetDate]);

    return useMemo(() => {
        let sec = secondsLeft;
        const d = Math.floor(sec / 86400); sec -= d * 86400;
        const h = Math.floor(sec / 3600); sec -= h * 3600;
        const m = Math.floor(sec / 60); sec -= m * 60;
        const s = sec;
        return {
            d, h, m, s,
            compact: `${d}д ${h}г ${m}хв`,
        };
    }, [secondsLeft]);
}